/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiCSVMappingPayloadFromJSON(json) {
    return ApiCSVMappingPayloadFromJSONTyped(json, false);
}
export function ApiCSVMappingPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'csvUrl': !exists(json, 'csvUrl') ? undefined : json['csvUrl'],
        'delimiter': !exists(json, 'delimiter') ? undefined : json['delimiter'],
    };
}
export function ApiCSVMappingPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'csvUrl': value.csvUrl,
        'delimiter': value.delimiter,
    };
}
